export default "__VITE_ASSET__CGo2Sxnm__"